(() => {
  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'CRC';
  const money = (value) => {
    const n = Number(value);
    if (Number.isNaN(n)) return value;
    try {
      return new Intl.NumberFormat('es-CR', { style: 'currency', currency, maximumFractionDigits: 0 }).format(n);
    } catch (e) {
      return '₡' + Math.round(n).toLocaleString('es-CR');
    }
  };
  const esc = (s) => String(s ?? '').replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c]);

  /* ---------- Dropdowns: one open at a time, close on outside click / Esc ---------- */
  const initDropdowns = () => {
    const drops = Array.from(document.querySelectorAll('[data-ds-drop]'));
    drops.forEach((d) => {
      d.addEventListener('toggle', () => {
        if (d.open) drops.forEach((o) => { if (o !== d) o.open = false; });
      });
    });
    document.addEventListener('click', (e) => {
      drops.forEach((d) => { if (d.open && !d.contains(e.target)) d.open = false; });
    });
    document.addEventListener('keydown', (e) => {
      if (e.key !== 'Escape') return;
      drops.forEach((d) => {
        if (d.open) { d.open = false; d.querySelector('summary')?.focus(); }
      });
    });
  };

  /* ---------- Mobile menu ---------- */
  const initBurger = () => {
    const btn = document.querySelector('[data-ds-burger]');
    const nav = document.querySelector('[data-ds-nav]');
    if (!btn || !nav) return;
    btn.addEventListener('click', () => {
      const open = btn.getAttribute('aria-expanded') !== 'true';
      btn.setAttribute('aria-expanded', String(open));
      nav.classList.toggle('is-open', open);
    });
  };

  /* ---------- Live search ---------- */
  const initSearch = () => {
    const wrap = document.querySelector('[data-ds-search]');
    if (!wrap) return;
    const input = wrap.querySelector('input[name="q"]');
    const box = wrap.querySelector('.ds-search__results');
    let timer;
    let controller;
    let active = -1;

    const close = () => {
      box.hidden = true;
      input.setAttribute('aria-expanded', 'false');
      active = -1;
    };
    const items = () => Array.from(box.querySelectorAll('[role="option"]'));
    const setActive = (i) => {
      const list = items();
      if (!list.length) return;
      active = (i + list.length) % list.length;
      list.forEach((el, idx) => el.setAttribute('aria-selected', String(idx === active)));
      list[active].scrollIntoView({ block: 'nearest' });
    };

    const render = (q, data) => {
      const r = (data && data.resources && data.resources.results) || {};
      const products = r.products || [];
      const collections = r.collections || [];
      const allUrl = `${root}search?type=product&options%5Bprefix%5D=last&q=${encodeURIComponent(q)}`;
      let html = '';
      if (collections.length) {
        html += `<div class="ds-search__group"><p class="ds-search__label">Colecciones</p><div class="ds-search__chip-row">${collections
          .map((c) => `<a class="ds-search__chip" role="option" href="${esc(c.url)}">${esc(c.title)}</a>`)
          .join('')}</div></div>`;
      }
      if (products.length) {
        html += `<div class="ds-search__group"><p class="ds-search__label">Productos</p>${products
          .map((p) => {
            const img = p.featured_image && p.featured_image.url ? `<img src="${esc(p.featured_image.url + (p.featured_image.url.includes('?') ? '&' : '?') + 'width=96')}" alt="" width="48" height="48" loading="lazy">` : '<span></span>';
            return `<a class="ds-search__item" role="option" href="${esc(p.url)}">${img}<span class="ds-search__item-title">${esc(p.title)}</span><span class="ds-search__item-price">${money(p.price)}</span></a>`;
          })
          .join('')}</div>`;
      }
      if (!products.length && !collections.length) {
        html = `<p class="ds-search__none">No encontramos resultados para “${esc(q)}”. Probá con otra palabra, como “proteína” o “creatina”.</p>`;
      } else {
        html += `<a class="ds-search__all" role="option" href="${allUrl}">Ver todos los resultados para “${esc(q)}”</a>`;
      }
      box.innerHTML = html;
      box.hidden = false;
      input.setAttribute('aria-expanded', 'true');
      active = -1;
    };

    const search = async (q) => {
      if (controller) controller.abort();
      controller = new AbortController();
      const url = `${root}search/suggest.json?q=${encodeURIComponent(q)}&resources[type]=product,collection&resources[limit]=6&resources[options][unavailable_products]=last&resources[options][fields]=title,product_type,variants.title,vendor`;
      try {
        const res = await fetch(url, { signal: controller.signal });
        if (!res.ok) throw new Error(res.status);
        render(q, await res.json());
      } catch (err) {
        if (err.name !== 'AbortError') close();
      }
    };

    input.addEventListener('input', () => {
      const q = input.value.trim();
      clearTimeout(timer);
      if (q.length < 2) { close(); return; }
      timer = setTimeout(() => search(q), 180);
    });
    input.addEventListener('keydown', (e) => {
      if (box.hidden) return;
      if (e.key === 'ArrowDown') { e.preventDefault(); setActive(active + 1); }
      else if (e.key === 'ArrowUp') { e.preventDefault(); setActive(active - 1); }
      else if (e.key === 'Enter' && active > -1) { e.preventDefault(); items()[active].click(); }
      else if (e.key === 'Escape') { close(); }
    });
    input.addEventListener('focus', () => { if (box.innerHTML && input.value.trim().length >= 2) { box.hidden = false; input.setAttribute('aria-expanded', 'true'); } });
    document.addEventListener('click', (e) => { if (!wrap.contains(e.target)) close(); });
  };

  /* ---------- One-tap add to cart ---------- */
  const toast = (text) => {
    const el = document.querySelector('[data-ds-toast]');
    if (!el) return;
    el.querySelector('[data-ds-toast-text]').textContent = text;
    el.hidden = false;
    clearTimeout(el._t);
    el._t = setTimeout(() => { el.hidden = true; }, 4500);
  };

  const refreshBubble = async () => {
    try {
      const res = await fetch(`${root}?sections=cart-icon-bubble`);
      const data = await res.json();
      const html = new DOMParser().parseFromString(data['cart-icon-bubble'], 'text/html');
      const inner = html.querySelector('.shopify-section');
      const bubble = document.getElementById('cart-icon-bubble');
      if (inner && bubble) bubble.innerHTML = inner.innerHTML;
    } catch (e) { /* the count updates on next page load */ }
  };

  const initQuickAdd = () => {
    document.addEventListener('submit', async (e) => {
      const form = e.target.closest('[data-ds-add]');
      if (!form) return;
      e.preventDefault();
      const btn = form.querySelector('button[type="submit"]');
      const label = btn.textContent;
      btn.setAttribute('aria-busy', 'true');
      btn.textContent = 'Agregando…';
      try {
        const res = await fetch(`${root}cart/add.js`, {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: new FormData(form),
        });
        const data = await res.json();
        if (!res.ok) throw new Error(data.description || data.message || 'No se pudo agregar');
        await refreshBubble();
        toast(`Agregaste ${btn.dataset.productTitle || 'el producto'} al carrito`);
        btn.textContent = 'Agregado';
        setTimeout(() => { btn.textContent = label; }, 1800);
      } catch (err) {
        toast(err.message || 'No se pudo agregar. Intentá de nuevo.');
        btn.textContent = label;
      } finally {
        btn.removeAttribute('aria-busy');
      }
    });
  };

  const start = () => { initDropdowns(); initBurger(); initSearch(); initQuickAdd(); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
